if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // ✅ BIO-TUNING FREQUENCY INPUT (optional)
      const freqInput =
        this.form.querySelector('[data-bio-frequency-input]') ||
        document.querySelector(`[data-bio-frequency-input][form="${this.form.id}"]`) ||
        document.querySelector('#cart_attribute');

      const freqErrorDiv = document.querySelector('#cart_attribute_error');

      const showFreqError = (msg) => {
        if (freqErrorDiv) freqErrorDiv.textContent = msg || '';
        if (freqInput) {
          if (msg) freqInput.setAttribute('aria-invalid', 'true');
          else freqInput.removeAttribute('aria-invalid');
        }
      };

      const validateFrequency = () => {
        // input nahi hai => skip
        if (!freqInput) return true;

        const raw = (freqInput.value || '').trim();

        // ✅ BLANK => allow add-to-cart (NO ERROR)
        if (!raw) {
          showFreqError('');
          return true;
        }

        const value = parseFloat(raw);

        if (Number.isNaN(value)) {
          showFreqError('Invalid number');
          return false;
        }
        if (value < 1 || value > 1000) {
          showFreqError('Value must be between 1 and 1000');
          return false;
        }

        showFreqError('');
        return true;
      };

      // ✅ Only block when user entered invalid value
      if (!validateFrequency()) {
        try {
          freqInput.focus();
          freqInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (e) {}
        return;
      }

      // ✅ Continue normal flow
      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      // ✅ IMPORTANT: formData was missing in your code
      const formData = new FormData(this.form);

      // ✅ Ensure chain size property is included (it may be outside the form element)
      const chainSizeInputs = document.querySelectorAll(`input[name="properties[Chain Size]"][form="${this.form.id}"]`);
      chainSizeInputs.forEach(input => {
        if (input.checked) {
          formData.append('properties[Chain Size]', input.value);
        }
      });

      // ✅ If frequency is blank, remove it from cart properties
      if (freqInput && !(freqInput.value || '').trim()) {
        formData.delete('properties[Bio-Tuning Frequency]');
      }

      // ✅ Get selected addon products
      const selectedAddons = this.getSelectedAddons();

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      // ✅ Add main product first
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          // ✅ If main product added successfully, add selected addons
          if (selectedAddons.length > 0) {
            return this.addAddonProducts(selectedAddons, response);
          }

          // ✅ No addons selected, proceed normally
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .then((finalResponse) => {
          // ✅ Handle final response after addons are added
          if (finalResponse && this.cart) {
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(finalResponse) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(finalResponse);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          const sp = this.querySelector('.loading-overlay__spinner');
          if (sp) sp.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    // ✅ Get selected addon products with their properties
    getSelectedAddons() {
      const addons = [];
      const checkboxes = document.querySelectorAll('[data-addon-checkbox]');
      
      checkboxes.forEach(checkbox => {
        if (checkbox.checked) {
          const productId = checkbox.dataset.productId;
          const variantId = checkbox.dataset.variantId;
          const type = checkbox.dataset.addonCheckbox;
          const properties = {};

          if (type === 'bio-tuning') {
            const freqInput = document.querySelector('[data-bio-frequency-input]');
            if (freqInput && freqInput.value && freqInput.value.trim()) {
              properties['Bio-Tuning Frequency'] = freqInput.value.trim();
            }
          } else if (type === 'engraving') {
            const engravingInput = document.querySelector('[data-engraving-input]');
            if (engravingInput && engravingInput.value && engravingInput.value.trim()) {
              properties['Engraving Message'] = engravingInput.value.trim();
            }
          }

          addons.push({
            productId: productId,
            variantId: variantId,
            type: type,
            properties: properties
          });
        }
      });

      return addons;
    }

    // ✅ Add addon products to cart sequentially
    async addAddonProducts(addons, mainResponse) {
      let lastResponse = mainResponse;
      
      for (const addon of addons) {
        try {
          // First, try to get variant ID from checkbox data attribute (set when product data was loaded)
          const checkbox = document.querySelector(`[data-addon-checkbox="${addon.type}"][data-product-id="${addon.productId}"]`);
          let variantId = checkbox?.dataset.variantId;
          
          // If not found in data attribute, fetch product HTML to get variant ID
          if (!variantId) {
            const htmlResponse = await fetch(`/products/${addon.productId}`);
            if (!htmlResponse.ok) continue;
            
            const html = await htmlResponse.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Method 1: Check product form
            const productForm = doc.querySelector('form[action*="/cart/add"]');
            if (productForm) {
              const hiddenIdInput = productForm.querySelector('input[name="id"]');
              if (hiddenIdInput) {
                variantId = hiddenIdInput.value;
              }
            }
            
            // Method 2: Check JSON scripts
            if (!variantId) {
              const productScripts = doc.querySelectorAll('script[type="application/json"]');
              for (const script of productScripts) {
                try {
                  const data = JSON.parse(script.textContent);
                  if (data.variants && data.variants.length > 0) {
                    variantId = data.variants[0].id;
                    break;
                  }
                } catch (e) {
                  continue;
                }
              }
            }
            
            // Method 3: Try to get from product handle endpoint
            if (!variantId) {
              try {
                const handleMatch = html.match(/\/products\/([^"'\s"']+)/);
                if (handleMatch) {
                  const handle = handleMatch[1].split('"')[0].split("'")[0].split('?')[0];
                  const jsonResponse = await fetch(`/products/${handle}.js`);
                  if (jsonResponse.ok) {
                    const product = await jsonResponse.json();
                    if (product.variants && product.variants.length > 0) {
                      variantId = product.variants[0].id;
                    }
                  }
                }
              } catch (e) {
                console.error('Error fetching variant via handle:', e);
              }
            }
          }
          
          // Use variant ID from addon data if available, otherwise use fetched one
          const finalVariantId = addon.variantId || variantId;
          
          if (!finalVariantId) {
            console.error(`Could not find variant ID for product ${addon.productId}`);
            continue;
          }

          // Prepare form data for addon
          const addonFormData = new FormData();
          addonFormData.append('id', finalVariantId);
          addonFormData.append('quantity', 1);
          
          // Add properties
          Object.keys(addon.properties).forEach(key => {
            if (addon.properties[key]) {
              addonFormData.append(`properties[${key}]`, addon.properties[key]);
            }
          });

          if (this.cart) {
            addonFormData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            addonFormData.append('sections_url', window.location.pathname);
          }

          const addonConfig = fetchConfig('javascript');
          addonConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete addonConfig.headers['Content-Type'];
          addonConfig.body = addonFormData;

          const addonResponse = await fetch(`${routes.cart_add_url}`, addonConfig);
          const addonResult = await addonResponse.json();
          
          if (!addonResult.status && this.cart) {
            lastResponse = addonResult;
          }
        } catch (error) {
          console.error(`Error adding addon product ${addon.productId}:`, error);
        }
      }

      return lastResponse;
    }
  });
}
